import * as Types from 'app/types/schema';

import gql from 'graphql-tag';
import * as Urql from 'app/libs/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PackedShippingContainersTableQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ShippingContainerFilters>;
  sorts?: Types.InputMaybe<Array<Types.SortProps> | Types.SortProps>;
  limit?: Types.InputMaybe<Types.Scalars['Float']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type PackedShippingContainersTableQuery = { __typename?: 'Query', packedShippingContainers: { __typename?: 'ShippingContainerConnection', totalCount: number, edges?: Array<{ __typename?: 'ShippingContainerEdge', node: { __typename?: 'ShippingContainerSchema', id: string, containerId: string, status: string, isReusable: boolean, destinationSite: { __typename?: 'LocationSchema', name: string, id: string }, shippingTransactions?: Array<{ __typename?: 'ShippingTransactionSchema', id: string, containerId: string, trackingId: string, createdAt: string, orderRequestId?: string | null, createdBy: { __typename?: 'UserSchema', name: string, id: string }, childEntities?: Array<{ __typename?: 'ShippingTransactionChildEntitySchema', entityId: string, entityType: string }> | null, orderRequest?: { __typename?: 'OrderRequestSchema', id: string, orderRequestCode: string, createdAt: string, deliverTo: { __typename?: 'UserSchema', name: string, id: string } } | null, items: Array<{ __typename?: 'ShippingTransactionInventoryItemSchema' } | { __typename?: 'ShippingTransactionOrderRequestItemSchema', itemId: string, itemType: Types.ItemTypeEnum, quantity: number, orderRequestItem: { __typename?: 'OrderRequestItemSchema', id: string, item?: { __typename?: 'AssetItemSchema', id: string, cost?: number | null, sku: string, title: string, type: Types.ItemTypeEnum, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null }> | null } | { __typename?: 'AssetKitItemSchema', id: string, cost?: number | null, sku: string, title: string, type: Types.ItemTypeEnum, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null }> | null } | { __typename?: 'AssetModelItemSchema' } | { __typename?: 'InventoryItemSchema', id: string, cost?: number | null, sku: string, title: string, type: Types.ItemTypeEnum, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null }> | null } | { __typename?: 'InventoryKitItemSchema', id: string, cost?: number | null, sku: string, title: string, type: Types.ItemTypeEnum, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null }> | null } | null } }> }> | null } }> | null, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, nextCursor?: string | null, prevCursor?: string | null } | null } };


export const PackedShippingContainersTableDocument = gql`
    query packedShippingContainersTable($filters: ShippingContainerFilters, $sorts: [SortProps!], $limit: Float, $after: String, $before: String) {
  packedShippingContainers(
    filters: $filters
    sorts: $sorts
    limit: $limit
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        containerId
        status
        isReusable
        destinationSite {
          name
          id
        }
        shippingTransactions {
          id
          containerId
          trackingId
          createdAt
          createdBy {
            name
            id
          }
          childEntities {
            entityId
            entityType
          }
          orderRequestId
          orderRequest {
            id
            orderRequestCode
            createdAt
            deliverTo {
              name
              id
            }
          }
          items {
            ... on ShippingTransactionOrderRequestItemSchema {
              itemId
              itemType
              quantity
              orderRequestItem {
                id
                item {
                  ... on AssetItemSchema {
                    id
                    cost
                    sku
                    attachments {
                      url
                    }
                    title
                    type
                  }
                  ... on AssetKitItemSchema {
                    id
                    cost
                    sku
                    attachments {
                      url
                    }
                    title
                    type
                  }
                  ... on InventoryItemSchema {
                    id
                    cost
                    sku
                    attachments {
                      url
                    }
                    title
                    type
                  }
                  ... on InventoryKitItemSchema {
                    id
                    cost
                    sku
                    attachments {
                      url
                    }
                    title
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
    }
    totalCount
  }
}
    `;

export function usePackedShippingContainersTableQuery(options?: Omit<Urql.UseQueryArgs<PackedShippingContainersTableQueryVariables>, 'query'>) {
  return Urql.useQuery<PackedShippingContainersTableQuery>({ query: PackedShippingContainersTableDocument, ...options });
};